import React, { useEffect } from 'react';
import { useAnalytics } from '../hooks/useAnalytics';
/**
 * Simple component to track page views automatically
 * Add this to any page component that needs tracking
 */
export function PageTracker() {
  const {
    trackPageView
  } = useAnalytics();
  useEffect(() => {
    trackPageView();
  }, [trackPageView]);
  return null;
}